/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { array } from 'prop-types';

import Button from 'components/Button/Button';

import styles from './buttons-block.scss';

/**
 * This is the ButtonsBlock component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default class ButtonsBlock extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    items: array,
  };

  static defaultProps = {
    items: [],
  };

  /**
   * Render ButtonsBlock.
   *
   * @return {Object}
   */
  render() {
    const { items } = this.props;

    return (
      <ul className={styles.wrapper}>
        {items.map(({ text, url }) => (
          <li key={url}>
            <Button wide path={url}>
              {text}
            </Button>
          </li>
        ))}
      </ul>
    );
  }
}
